import { useState } from 'react'
import type { OrderStageView } from '@/api/types'
import { Card, EmptyState, ErrorState, LoadingState, StageStepper } from '@/ui'
import { StageActionSheet } from '@/features/production/StageActionSheet'
import { useOrderStages } from '../queries'

export function StagesTab({ orderId }: { orderId: string }) {
  const { data, isLoading, isError, error, refetch } = useOrderStages(orderId)
  const [selected, setSelected] = useState<OrderStageView | null>(null)

  if (isLoading) return <LoadingState />
  if (isError) return <ErrorState error={error} onRetry={() => void refetch()} />
  if (!data || data.items.length === 0) {
    return <EmptyState title="Этапов нет" hint="Этапы появятся после запуска заказа в производство." />
  }

  return (
    <>
      <Card className="p-4">
        <StageStepper stages={data.items} onSelect={setSelected} />
      </Card>
      <p className="mt-2 px-1 text-xs text-tg-hint">Нажмите на этап, чтобы выполнить действие.</p>
      {selected && (
        <StageActionSheet
          orderId={orderId}
          stage={selected}
          open
          onClose={() => setSelected(null)}
        />
      )}
    </>
  )
}
